"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialProvider = void 0;
var react_1 = __importDefault(require("react"));
var useLoad_1 = require("../hook/useLoad");
var useMedia_1 = require("../hook/useMedia");
var useScrollToTop_1 = require("../hook/useScrollToTop");
var useResetSelectCar_1 = require("../hook/useResetSelectCar");
var usePageTitle_1 = require("../hook/usePageTitle");
var InitialProvider = function (_a) {
    var children = _a.children;
    (0, useLoad_1.useLoad)();
    (0, useMedia_1.useMedia)();
    (0, useScrollToTop_1.useScrollToTop)();
    (0, useResetSelectCar_1.useResetSelectCar)();
    (0, usePageTitle_1.usePageTitle)();
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.InitialProvider = InitialProvider;
